import React from "react";
import Cropper from "cropperjs";
import { Box } from "reflexbox";
import styled from "styled-components";

const StyledImg = styled.img`
  display: block;
  max-width: 100%;
`;

const ImageCropper = ({ image = "" }) => {
  const cropper = new Cropper(image, {
    aspectRatio: 16 / 9,
    crop(event) {
      console.log(event);
      console.log(event.detail.x);
      console.log(event.detail.y);
      console.log(event.detail.width);
      console.log(event.detail.height);
      console.log(event.detail.rotate);
      console.log(event.detail.scaleX);
      console.log(event.detail.scaleY);
    },
  });

  return (
    <Box width={1}>
      <StyledImg src={image} />
      {cropper}
    </Box>
  );
};

export default ImageCropper;
